var _rect, _text, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementWordmarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 56",
    role: "img",
    "aria-label": "Berlin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 56,
    rx: 8,
    fill: "#7f1d1d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 38,
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: -0.5
  }, "berlin")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 38,
    r: 7,
    fill: "#f07167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementWordmarkLight);
export default __webpack_public_path__ + "static/media/element-wordmark-light.f9de44423a0ec5c22a3626a17154667f.svg";
export { ForwardRef as ReactComponent };